import React, { Component } from "react";
import { Loader, Dimmer, Button, Message, Tab } from "semantic-ui-react";

import "./Settings.css";

import ErrorAlert from "../ErrorAlert/ErrorAlert";
import { ErrorHandler } from "../../utils/UtilMethods";
import PackagingType from "./components/PackagingType";
import OperatorEndpoints from "../../lib/operator/OperatorEndpoints";
import SettingsEndpoints from "../../lib/settings/SettingsEndpoints";

const limaPath = "https://la.site.se";

const defaultErrorMessage = "Något gick fel.";

export default class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authorized: false,
      packagingTypes: {},
      currentError: "",
      loading: true,
    };
  }
  componentDidMount() {
    this.authorizedLogin();
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.state.authorized && !prevState.authorized) {
      this.getSettings();
    }
  }
  authorizedLogin() {
    OperatorEndpoints.authorizedLogin(this.props.loginKey)
      .then((result) => {
        this.validAuthorization();
      })
      .catch((error) => {
        this.unvalidAuthorization(error);
      });
  }
  getSettings() {
    SettingsEndpoints.getPackagingTypes()
      .then((result) => {
        this.setState({ packagingTypes: result.types, loading: false });
      })
      .catch((error) => {
        ErrorHandler.addError(error, (message) =>
          this.setState({ currentError: message, loading: false })
        );
      });
  }
  validAuthorization() {
    this.setState({ authorized: true });
  }
  unvalidAuthorization(error) {
    this.showErrorAlert(error);
    this.redirectToLima();
  }
  updateDbError(error) {
    this.showErrorAlert(error);
    document.location.reload();
  }
  showErrorAlert(error) {
    let message = (error && error.message) || defaultErrorMessage;
    alert(message);
  }
  redirectToLima() {
    document.location.href = limaPath;
  }
  onChangePackagingType(conveyorID, newPackagingTypes) {
    let { packagingTypes } = this.state;
    packagingTypes[conveyorID] = newPackagingTypes;
    SettingsEndpoints.setPackagingTypes(packagingTypes)
      .then((result) => {
        if (result) {
          this.setState({ packagingTypes });
        }
      })
      .catch((error) => {
        this.updateDbError(error);
      });
  }
  renderHeader() {
    return (
      <React.Fragment>
        <Message size="massive" className="Title" info>
          Inställningar
        </Message>
        <Button className="RedirectButton" primary onClick={() => this.redirectToLima()}>
          Återgå till Lima
        </Button>
      </React.Fragment>
    );
  }

  render() {
    let { authorized, currentError, packagingTypes, loading } = this.state;

    if (!authorized || loading) {
      return (
        <Dimmer active inverted>
          <Loader size="big" />
        </Dimmer>
      );
    }

    return (
      <div className="SettingsContainer">
        {this.renderHeader()}
        <Tab
          className="SettingsTab"
          menu={{ fluid: true, vertical: true, tabular: true }}
          panes={[
            {
              menuItem: "Emballage",
              render: () => (
                <PackagingType
                  packagingTypes={packagingTypes}
                  onChange={(conveyorId, packagingTypes) =>
                    this.onChangePackagingType(conveyorId, packagingTypes)
                  }
                />
              ),
            },
          ]}
        />
        <ErrorAlert error={currentError} />
      </div>
    );
  }
}
